import "../stylesheets/ThanksForSubmitScreen.css";

import React from "react";
import { FaRegPaperPlane } from "react-icons/fa";

/** @typedef {{ anonymous: boolean, title: string, files: boolean }} Props */

export default class ThanksForSubmitScreen extends React.PureComponent {

    /** @type {Props} */
    props;

    /**
     * @param {Props} props 
     */
    constructor(props) {
        super(props);
        this.text = `Dein Beitrag "${props.title}" ${props.files ? "sowie deine hochgeladenen Dateien werden" : "wird"} auf einem verschlüsselten Server gespeichert.`;
    }

    render() {

        return (

            <div className="flexContainer secondaryColorBackground centeredHorizontal centeredVertical">
                <h1 className="ThanksForSubmitScreenHeader" >Danke für deinen Beitrag!</h1>

                <FaRegPaperPlane className="ThanksForSubmitScreenPadding" size="15em" />
                
                <p className="ThanksForSubmitScreenText ThanksForSubmitScreenPadding centeredText" >{this.text}</p>

                {this.props.anonymous ? <p className="ThanksForSubmitScreenText centeredText" >Da du keinen Namen angeben hast wird dein Beitrag volkommen anonym hinterlegt.</p> : null}
            </div>

        );

    }
    
}